var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.43221 3.53833L1.66805 16.5C1.50797 16.7772 1.42327 17.0915 1.42237 17.4116C1.42147 17.7318 1.50441 18.0465 1.66294 18.3246C1.82146 18.6028 2.05005 18.8345 2.32595 18.9969C2.60185 19.1592 2.91545 19.2465 3.23555 19.25H18.7639C19.084 19.2465 19.3976 19.1592 19.6735 18.9969C19.9494 18.8345 20.178 18.6028 20.3365 18.3246C20.495 18.0465 20.578 17.7318 20.5771 17.4116C20.5762 17.0915 20.4915 16.7772 20.3314 16.5L12.5672 3.53833C12.4038 3.26893 12.1737 3.04619 11.8991 2.89161C11.6246 2.73702 11.3148 2.65582 10.9997 2.65582C10.6846 2.65582 10.3749 2.73702 10.1003 2.89161C9.82572 3.04619 9.59563 3.26893 9.43221 3.53833V3.53833Z",
    stroke: "#F2617B",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.25V11.9167",
    stroke: "#F2617B",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.5833H11.0088",
    stroke: "#F2617B",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.1049fca8.svg";
export { ForwardRef as ReactComponent };